// src/components/SessionListener.js
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getToken, isTokenExpired, removeToken } from '../utils/AuthUtils';

const SessionListener = () => {
  const history = useHistory();

  useEffect(() => {
    // Session check function
    const checkSession = () => {
      // Skip check on login page
      if (window.location.pathname === '/login') return;
      
      const token = getToken();
      
      // Case 1: No token exists at all
      if (!token) {
        alert('You are not logged in. You will be redirected to the login page.');
        history.push('/login');
        return;
      }
      
      // Case 2: Token exists but has expired
      if (isTokenExpired()) {
        // Show alert before redirecting
        alert('Your session has expired. You will be redirected to the login page.');
        
        // Clear token and redirect to login
        removeToken();
        history.push('/login');
      }
    };

    // Create a debounced function to avoid too many checks
    let timeoutId;
    const debouncedCheck = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(checkSession, 500);
    };

    // Set periodic session check (every 1 minute)
    const intervalId = setInterval(checkSession, 60000);
    
    // Check on specific user actions instead of all clicks
    document.addEventListener('mousedown', debouncedCheck);
    document.addEventListener('keydown', debouncedCheck);
    window.addEventListener('focus', checkSession);
    
    // Clean up
    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      document.removeEventListener('mousedown', debouncedCheck);
      document.removeEventListener('keydown', debouncedCheck);
      window.removeEventListener('focus', checkSession);
    };
  }, [history]);

  // This component doesn't render anything
  return null;
};

export default SessionListener;